import { useDestroySessionMutation } from "@graphql/auth/auth.g";
import { useNavigate } from "react-router";

import { queryClient } from "@api/queries";

import { CurrentUser } from "@components/CurrentUser/CurrentUser";
import { ThemeSelect } from "@components/ThemeSelect/ThemeSelect";
import { TimezoneSelect } from "@components/TimezoneSelect/TimezoneSelect";

import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";

import { routes } from "@pages/routes";

import { clearTenantSchemaTag } from "../../../sentry";

export const ProfileCard = () => {
  const destroySessionMutation = useDestroySessionMutation();
  const destroySession = destroySessionMutation.mutateAsync;
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    sessionStorage.removeItem("impersonation_session");
    clearTenantSchemaTag();
    await destroySession({});
    queryClient.clear();

    navigate(routes.login.$path(), { viewTransition: true });
  };

  return (
    <Card>
      <Card.Body gap={16}>
        <CurrentUser />
        <ThemeSelect />
        <TimezoneSelect />
        <Button
          variant="outlined"
          onClick={handleLogoutClick}
          uppercase
          size="sm"
        >
          Logout
        </Button>
      </Card.Body>
    </Card>
  );
};
